import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlueprintSummaryComponent } from './blueprint-summary.component';
import { ToolbarButton } from '../../../models/toolbar-button/toolbar-button';
import { InstanceDetailsComponent } from './instance-details/instance-details.component';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionGuard } from 'src/app/services/util/permission.guard';

const routes: Routes = [{
  path: '',
  component: BlueprintSummaryComponent,
  data: {
    activeLink: ToolbarButton.CATALOGUE
  }
},{
  path: 'instance/:instanceId',
  component: InstanceDetailsComponent,
  canActivate: [PermissionGuard],
  data: {
    activeLink: ToolbarButton.CATALOGUE,
    permissionRule: {
      not: Permission.NO_SERVICES
    }
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlueprintSummaryRoutingModule {
}
